import React from 'react';
import { Button, Typography, Paper, Table, TableBody, TableCell, TableRow, TableHead } from '@mui/material';
import { styled } from '@mui/system';

const dummyInvoice = {
  billTo: 'Kavindra Manran, 27, City Apts, Ghat Rd, Delhi, Delhi 400003',
  shipTo: 'Kavindra Manran, 37, Ambit Mansion, Ashok Bazar, Mumbai, Maharashtra 400001',
  invoiceNumber: 'INV-001',
  invoiceDate: '20-06-2024',
  dueDate: '20-07-2024',
  items: [
    { sno: 1, description: 'Frontend design restructure', quantity: 1, unitPrice: 999.00, discount: 0, gst: 18, amount: 999.00 },
    { sno: 2, description: 'Custom icon design', quantity: 2, unitPrice: 150.00, discount: 0, gst: 18, amount: 300.00 },
    { sno: 3, description: 'Gendhi mouse pad', quantity: 3, unitPrice: 50.00, discount: 0, gst: 18, amount: 150.00 }
  ],
  subtotal: 1449.00,
  discount: 0,
  gst: 72.45,
  total: 1521.45,
  terms: 'Payment is due within 15 days. State Bank of India, Account Number: 12345678, Routing Number: 0987654321',
};

const InvoiceContainer = styled(Paper)({
  padding: '20px',
  margin: '20px auto',
  backgroundColor: '#fff',
  maxWidth: '800px', // Reduce the width of the page
  position: 'relative',
});

const InvoiceHeader = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '20px',
});

const InvoiceDetailsSection = styled('div')({
  marginBottom: '20px',
});

const InvoiceFooter = styled('div')({
  marginTop: '20px',
  textAlign: 'center',
});

const TableHeadStyled = styled(TableHead)({
  backgroundColor: '#f0f0f0',
});

const handlePrint = () => {
  window.print();
};

const handleDownload = () => {
  const element = document.createElement("a");
  const file = new Blob([JSON.stringify(dummyInvoice, null, 2)], { type: 'application/json' });
  element.href = URL.createObjectURL(file);
  element.download = `Invoice-${dummyInvoice.invoiceNumber}.json`;
  document.body.appendChild(element);
  element.click();
};

const InvoiceDetails = () => {
  return (
    <InvoiceContainer>
      <InvoiceHeader>
        <Typography variant="h4">Invoice</Typography>
        <img src="/assets/images/jack_logo.png" alt="Logo" style={{ height: '90px' }} />
      </InvoiceHeader>
      
      <InvoiceDetailsSection>
        <Typography variant="body1"><strong>Bill To:</strong> {dummyInvoice.billTo}</Typography>
        <Typography variant="body1"><strong>Ship To:</strong> {dummyInvoice.shipTo}</Typography>
        <Typography variant="body1"><strong>Invoice #:</strong> {dummyInvoice.invoiceNumber}</Typography>
        <Typography variant="body1"><strong>Invoice Date:</strong> {dummyInvoice.invoiceDate}</Typography>
        <Typography variant="body1"><strong>Due Date:</strong> {dummyInvoice.dueDate}</Typography>
      </InvoiceDetailsSection>

      <Table>
        <TableHeadStyled>
          <TableRow>
            <TableCell><strong>SNo</strong></TableCell>
            <TableCell><strong>Items</strong></TableCell>
            <TableCell><strong>Quantity</strong></TableCell>
            <TableCell><strong>Unit Price</strong></TableCell>
            <TableCell><strong>Discount</strong></TableCell>
            <TableCell><strong>GST</strong></TableCell>
            <TableCell><strong>Amount</strong></TableCell>
          </TableRow>
        </TableHeadStyled>
        <TableBody>
          {dummyInvoice.items.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{item.sno}</TableCell>
              <TableCell>{item.description}</TableCell>
              <TableCell>{item.quantity}</TableCell>
              <TableCell>{item.unitPrice.toFixed(2)}</TableCell>
              <TableCell>{item.discount}</TableCell>
              <TableCell>{item.gst}%</TableCell>
              <TableCell>{item.amount.toFixed(2)}</TableCell>
            </TableRow>
          ))}
          <TableRow>
         
            <TableCell colSpan={6}><strong>Subtotal</strong></TableCell>
            <TableCell>{dummyInvoice.subtotal.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={6}><strong>Discount</strong></TableCell>
            <TableCell>{dummyInvoice.discount.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={6}><strong>GST</strong></TableCell>
            <TableCell>{dummyInvoice.gst.toFixed(2)}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={6}><strong>Total</strong></TableCell>
            <TableCell>{dummyInvoice.total.toFixed(2)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <InvoiceFooter>
        <Typography variant="body1" style={{ marginTop: '20px' }}><strong>Terms & Conditions:</strong> {dummyInvoice.terms}</Typography>
        <Typography variant="h6" style={{ marginTop: '40px', color: 'blue' }}>Thank you</Typography>
      </InvoiceFooter>
      
      <div style={{ textAlign: 'right', marginTop: '20px' }}>
        <Button onClick={handlePrint} color="primary" variant="contained" style={{ marginRight: '10px' }}>Print</Button>
        <Button onClick={handleDownload} color="secondary" variant="contained">Download</Button>
      </div>
    </InvoiceContainer>
  );
};

export default InvoiceDetails;
